/*
* вызывает события для страницы просмотра товаров
*/
import {biMarketingEventRunnerRun} from "../../WithBiMarketingEventRunner";
import {MarketingEventTypeEnum} from "../../../../enums/MarketingEventTypeEnum";
import {MarketingEventVariableTypeEnum} from "../../../../enums/MarketingEventVariableTypeEnum";

export function run() {
    // тут место где можно вызывать любые события, при загрузки страницы.
    // alert('ProductViewExecutor');
    // biMarketingEventRunnerRun({
    //     eventTypeId: MarketingEventTypeEnum.viewProductCard,
    //     dynamicData: {
    //         [MarketingEventVariableTypeEnum.marketingProductId]: 16,
    //         [MarketingEventVariableTypeEnum.productName]: 'testName',
    //         [MarketingEventVariableTypeEnum.productPrice]: 6322,
    //         [MarketingEventVariableTypeEnum.currency]: 'RUB',
    //         [MarketingEventVariableTypeEnum.productBrand]: 'testBrand',
    //         [MarketingEventVariableTypeEnum.productCategory]: 'testCategory',
    //     }
    // });
}